import * as React from 'react';

import { TextInput } from '../../components/forms';

interface Props {
	assessment: any;
	customerDetails: CustomerDemographicDetailsDto;
	onAssessmentChange: (e: any) => void;
	onCustomerDetailsChange: (e: any) => void;
	onCustomerDetailsNumberKeyUp: (e: any) => void;
	onAssessmentChildrenChange: (e: any) => void;
	onAssessmentChildChange: (e: any, index: number) => void;
}
const Questionnaire: React.StatelessComponent<Props> = props => {
	const childText = props.assessment.numChildren === '1' ? 'child' : 'children';
	const childIs = props.assessment.numChildren === '1' ? 'is' : 'are';
	const eachChildText = props.assessment.numChildren === '1' ? 'my' : 'each';
	return (
		<fieldset>
			<div className="form-group">
				<div className="form-inline">
					<div className="form-group form-inline-text">I have</div>
					<TextInput
						type="number"
						name="numChildren"
						className="form-group-number-2"
						min={0}
						onChange={props.onAssessmentChildrenChange}
						value={props.assessment.numChildren}
					/>
					<div className="form-group form-inline-text">{childText} under 18.</div>
					{props.assessment.numChildren > 0 && <div className="form-group form-inline-text">My {childText} {childIs}</div>}
					{props.assessment.childrenAge.map((childAge: number, index: number) => {
						return [
							index > 0 &&
							<div key={index + 'a'} className="form-group form-inline-text">
								{index === props.assessment.childrenAge.length - 1 ?
									props.assessment.childrenAge.length === 2 ? 'and' : ', and'
									: ','
								}
							</div>,
							<TextInput
								key={index + 'b'}
								type="number"
								id={`childAge${index}`}
								name={`childAge${index}`}
								className="form-group-number-2"
								min={0}
								onChange={e => props.onAssessmentChildChange(e, index)}
								value={childAge}
							/>
						];
					})}
					{props.assessment.numChildren > 0 && <div className="form-group form-inline-text">years old.</div>}
				</div>
			</div>
			{props.assessment.numChildren > 0 &&
				<div className="form-group">
					<div className="form-inline">
						<div className="form-group form-inline-text">I plan to pay</div>
						<TextInput
							name="educationAmount"
							className="mr-0 form-group-number-10"
							addOnBefore="$"
							onChange={props.onCustomerDetailsChange}
							onKeyUp={props.onCustomerDetailsNumberKeyUp}
							value={props.customerDetails.educationAmount}
						/>
						<div className="form-group form-inline-text">for {eachChildText} child's education.</div>
					</div>
				</div>
			}
			<div className="form-group">
				<div className="form-inline">
					<div className="form-group form-inline-text">My mortgage balance is around</div>
					<TextInput
						name="mortgage"
						className="form-group-number-10"
						addOnBefore="$"
						onChange={props.onCustomerDetailsChange}
						onKeyUp={props.onCustomerDetailsNumberKeyUp}
						value={props.customerDetails.mortgage}
					/>
					<div className="form-group  form-inline-text">and</div>
				</div>
			</div>
			<div className="form-group">
				<div className="form-inline">
					<div className="form-group form-inline-text">I have other debts of</div>
					<TextInput
						name="otherDebt"
						className="mr-0 form-group-number-10"
						addOnBefore="$"
						onChange={props.onCustomerDetailsChange}
						onKeyUp={props.onCustomerDetailsNumberKeyUp}
						value={props.customerDetails.otherDebt}
					/>
					<div className="form-group form-inline-text">.</div>
				</div>
			</div>
			<div className="form-group">
				<div className="form-inline">
					<div className="form-group form-inline-text">If I die I want my beneficiaries to share</div>
					<TextInput
						name="beneficiaryAmountPerYear"
						addOnBefore="$"
						className="form-group-number-10"
						onChange={props.onCustomerDetailsChange}
						onKeyUp={props.onCustomerDetailsNumberKeyUp}
						value={props.customerDetails.beneficiaryAmountPerYear}
					/>
					<div className="form-group form-inline-text">per year for</div>
					<TextInput
						name="beneficiaryAmountTotalYears"
						className="form-group-number"
						pattern="[0-9]*"
						onChange={props.onCustomerDetailsChange}
						value={props.customerDetails.beneficiaryAmountTotalYears}
					/>
					<div className="form-group form-inline-text">years (excluding mortgage payments and saving for education).</div>
				</div>
			</div>
			<div className="form-group">
				<div className="form-inline">
					<div className="form-group form-inline-text">I have approximately</div>
					<TextInput
						name="savingsAmount"
						addOnBefore="$"
						className="form-group-number-10"
						onChange={props.onCustomerDetailsChange}
						onKeyUp={props.onCustomerDetailsNumberKeyUp}
						value={props.customerDetails.savingsAmount}
					/>
					<div className="form-group form-inline-text">in savings and</div>
					<TextInput
						name="existingLifeInsurance"
						addOnBefore="$"
						className="form-group-number-10"
						onChange={props.onCustomerDetailsChange}
						onKeyUp={props.onCustomerDetailsNumberKeyUp}
						value={props.customerDetails.existingLifeInsurance}
					/>
					<div className="form-group form-inline-text">in existing life insurance.</div>
				</div>
			</div>
		</fieldset >
	);
};

export default Questionnaire;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/advisory/Questionnaire.tsx